import { UserInfoDetails } from "../types";


export const loginUserInfoDetails: UserInfoDetails = {
    id: "",
    expiration_date: "",
    email: "",
    token: "",
    timestamp: "",
    firstname: "",
    lastname: "",
    roleTypeId: 0,
    accessibleSystemGroup: [],
    profileStatus: 0,
    features: {
        organization: 0,
        building: 0,
        gateway: 0,
        system: 0,
        Luminaires: 0,
        firmwareUpgrade: 0,
        dashboard: 0,
        alarms: 0,
        inviteUser: 0,
        notification: 0,
        createServiceManager: 0,
        clusterReporting: 0,
        healthReporting: 0,
        prefilledInspectionReport: 0,
        sparePartListCreation: 0,
        deviceReplaceConfigFileSavedOnCloud: 0,
        fourGSupport: 0,
        customReportsLogoAndReportTemplates: 0,
        servicePartnerDashboard: 0,
        userGroupManagementCustomerCard: 0,
        remainingLifeSpan: 0,
        secureRemoteControl: 0,
        predictiveMaintenance: 0,
        LinkSystemLimitations: 0,
        createPlatforms: 0,
        userGroupManagementServicePartnerCustomer: 0
    }
}

export type AuthenticationState = {
    isAuthenticating: boolean;
    login: {
        loading: boolean;
        errorCode: number;
        errorMessage: string;
    };
    forgotPassword: {
        loading: boolean;
        success: boolean;
        errorMessage: string;
    };
    setPassword: {
        requested: boolean;
        pending: boolean;
        success: boolean;
        failure: boolean;
        errorCode: string;
    };
    verifyResetCode: {
        code: string;
        pending: boolean;
        success: boolean;
    };
    preloadData: {
        loading: boolean;
        success: boolean;
    };
    loginUserInfo: {
        loginUserInfoLoading: boolean;
        loginUserInfoSuccess: boolean;
        loginUserInfoFail: boolean;
        loginUserInfo: UserInfoDetails;
        loginUserInfoErrorCode: string;
    }

};

export const initialAuthenticationState: AuthenticationState = {
    isAuthenticating: false,
    login: {
        errorCode: 0,
        errorMessage: '',
        loading: false,
    },
    setPassword: {
        requested: false,
        pending: false,
        success: false,
        failure: false,
        errorCode: ''
    },
    forgotPassword: {
        loading: false,
        errorMessage: '',
        success: false,
    },
    verifyResetCode: {
        code: '',
        pending: false,
        success: false,
    },
    preloadData: {
        loading: false,
        success: false,
    },
    loginUserInfo: {
        loginUserInfoLoading: false,
        loginUserInfoSuccess: false,
        loginUserInfoFail: false,
        loginUserInfo: loginUserInfoDetails,
        loginUserInfoErrorCode: ''
    }
};
